export enum BookingsRoutingRoots {
	RELIEF = 'relief',
	PRELEASE = 'prelease',
	ACI = 'rsa',
	NEW_ENTRY = 'newentry',
	ACI_RESERVATION_LIST = 'reservation-list',
	HISTORY_RESERVATION_LIST = 'reservation-list',
	RESERVATION_LIST = 'reservationlist',
	BOOKING_HISTORY = 'booking-history',
	CHECKIN = 'checkin',
	CHECKOUT = 'checkout',
	RESERVATION_DETAILS = 'reservation-details',
	CHANGE_VEHICLE_REQUEST = 'change-vehicle',
	RESERVATION_HISTORY_DETAILS = 'reservation-history-details',
	MASTER_DATA = 'master-data',
	PERSONAL_DATA = 'personal-data',
	SETTINGS = 'settings',
	CUSTOMER = 'customer',
	PLATES = 'plates',
	ANAGRAFICHE ='anagrafiche',
	DASHBOARD = 'dashboard',
	SIGN = 'sign',
	RAC ='rac',
	ACI_DETAILS = 'rsa-details',
	MOBILITY_RESERVATION_LIST = 'mobility-reservation-list',
	MOBILITY_RESERVATION_DETAIL = 'mobility-reservation-detail',
}
